import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  screenReaderText: {
    id: 'category.generic.loading',
    defaultMessage: 'Loading...',
    description: 'Screen-reader message for when a page is loading.',
  },
});

export default messages;
